module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@2x-bc63a4b19f94ca9ed7915979a5f6004e.png";